import { memo } from 'react';
import { Box, Flex, Skeleton } from '@chakra-ui/react';

import {
  PLAN_CHART_VIEW_HEIGHT,
  PLAN_KPI_SELECTED_BG,
  PLAN_TABLE_TOOLBAR_HEIGHT,
} from '../planPageRevampUi';

interface Properties {
  fillHeight?: boolean;
  chartAreaHeight?: string;
  surfaceColor: string;
  horizontalPadding?: number;
}

const skeletonProperties = {
  startColor: 'gray.100',
  endColor: 'gray.200',
  borderRadius: '4px',
} as const;

const PlanChartSkeleton = ({
  fillHeight = false,
  chartAreaHeight,
  surfaceColor,
  horizontalPadding = 0,
}: Properties) => {
  const resolvedChartHeight = chartAreaHeight ?? PLAN_CHART_VIEW_HEIGHT;

  return (
    <Box
      display='flex'
      flexDirection='column'
      h={fillHeight ? '100%' : 'auto'}
      flex={fillHeight ? '1' : undefined}
      flexShrink={fillHeight ? undefined : 0}
      bg={surfaceColor}
      overflow='hidden'
    >
      <Flex
        h={PLAN_TABLE_TOOLBAR_HEIGHT}
        alignItems='center'
        justifyContent='flex-end'
        gap={3}
        px={4}
        flexShrink={0}
        bg={PLAN_KPI_SELECTED_BG}
      >
        <Skeleton height='28px' width='140px' {...skeletonProperties} />
        <Skeleton height='28px' width='28px' {...skeletonProperties} />
        <Skeleton height='28px' width='28px' {...skeletonProperties} />
        <Skeleton height='40px' width='129px' {...skeletonProperties} />
      </Flex>

      <Box
        flex={fillHeight ? '1' : undefined}
        h={fillHeight ? undefined : resolvedChartHeight}
        minH={fillHeight ? 0 : resolvedChartHeight}
        px={horizontalPadding}
        py={4}
        flexShrink={0}
      >
        <Skeleton height='100%' minH='200px' {...skeletonProperties} />
      </Box>

      <Box px={horizontalPadding} pb={4} flexShrink={0}>
        <Skeleton height='24px' width='100%' mb={3} {...skeletonProperties} />
        <Flex gap={4} flexWrap='wrap'>
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton key={index} height='12px' width='96px' {...skeletonProperties} />
          ))}
        </Flex>
      </Box>
    </Box>
  );
};

export default memo(PlanChartSkeleton);
